import { z } from 'zod'

const FeatureFlagSchema = z
  .object({
    feature_key: z.string(),
    enabled: z.boolean(),
  })
  .transform(({ feature_key, enabled }) => ({
    featureKey: feature_key,
    enabled,
  }))

export const FeatureFlagsSchema = z.array(FeatureFlagSchema)

export type FeatureFlags = z.infer<typeof FeatureFlagsSchema>
